export const SINGLE = "single"
export const COUPLE = "couple"
export const MULTI = "multi"